const AccordionItem = () => { return import(/* webpackChunkName: 'accordion-item' */ './AccordionItem.vue'); };

export {
    AccordionItem,
};
